import '../style/App.css';

import aaurelion from '../pics/aaurelion.jpg'
import claael from '../pics/claael.jpg'
import diaadree from '../pics/diaadree.jpg'
import osaalo from '../pics/osaalo.jpg'
import naal from '../pics/naal.jpg'
import naath from '../pics/naath.jpg'
import yathira from '../pics/yathira.jpg'
import mylaakChaos from '../pics/mylaakChaos.jpg'
import Card from './Card';

const Pantheon = () => {
  return (
        <div className='page'>
            
            <Card img={diaadree} name={"Diaadree"} desc={"Heart of the Living Wilds"} />
            <Card img={osaalo} name={"Osaalo"} desc={"Marrow of the Silent Wilds"} />
            <Card img={claael} name={"Claael"} desc={"Warden of the Creators Cast"} />

            <Card img={aaurelion} name={"Aaurelion"} desc={"The Lord of Runes"} />
            <Card img={mylaakChaos} name={"Mylaak"} desc={"God of Chaos"} />
            <Card img={yathira} name={"Yaathira"} desc={"Shepherd of the Forgotten"} />

            <Card img={naath} name={"Naath"} desc={"Keeper of Soul Passage"} />
            <Card img={naal} name={"Naal"} desc={"Soverign of There-After"} />

        </div>
    
  );
};

export default Pantheon;